// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1c49b07a","191":"2cdc6a68","319":"103103c4","357":"072730fe","422":"b832ddef","463":"dee9ea75","470":"39c4999b","473":"180d8dfd","645":"187a0282","651":"3d9c2351","688":"ade15b14","926":"02144f24","982":"983ce54e","994":"f4072088"}[chunkId] + ".chunk.js";
};